import formats from 'shared/address_presets/address_edit_formats.json';

import { CountryCode } from 'lib/constants/locales';
import { POSTAL_CODE_GB_REGEX, POSTAL_CODE_REGEX } from 'lib/constants/regexes';

export type AddressField = 'address1' | 'address2' | 'city' | 'postalCode' | 'subdivision';
type AddressFieldLabelMap = Record<AddressField, string>;

export interface Subdivision {
  code: string;
  untranslatedName: string;
}

export interface AddressFormat {
  untranslatedName: string;
  autocompletionField: string;
  postalCodeRegex?: RegExp;
  labels: Partial<AddressFieldLabelMap>;
  optionalLabels: AddressField[];
  formatting: AddressField[][];
  subdivisions: Subdivision[];
}

export const DEFAULT_LABELS: AddressFieldLabelMap = {
  address1: 'Street address',
  address2: 'Apt / Suite',
  city: 'City',
  postalCode: 'Postal code',
  subdivision: 'Region',
};

export const DEFAULT_ADDRESS_FORMAT: AddressFormat = {
  untranslatedName: 'Default',
  autocompletionField: 'address1',
  labels: {},
  optionalLabels: ['address2'],
  formatting: [['address1'], ['address2'], ['city', 'subdivision', 'postalCode']],
  subdivisions: [],
};

type AddressFormatsByCountryCode = { [cc in CountryCode]?: AddressFormat };

const ADDRESS_FORMATS_BY_COUNTRY_CODE: AddressFormatsByCountryCode =
  formats as AddressFormatsByCountryCode;

/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
ADDRESS_FORMATS_BY_COUNTRY_CODE['US'].postalCodeRegex = POSTAL_CODE_REGEX;
/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
ADDRESS_FORMATS_BY_COUNTRY_CODE['GB'].postalCodeRegex = POSTAL_CODE_GB_REGEX;

export { ADDRESS_FORMATS_BY_COUNTRY_CODE };
